import { Box as BaseBox } from '@mui/material';

export default function Box(props) {
  return <BaseBox {...props} />;
}


